import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../../components/SEO';

const Awards = () => {
  return (
    <>
      <SEO 
        title="Awards & Recognition - Abacies Logiciels"
        description="Recognized for excellence in AI solutions, software development, and digital transformation. View Abacies Logiciels' awards, certifications, and industry recognition."
        keywords="awards, recognition, certifications, industry awards, technology awards, Abacies awards, excellence recognition"
      />

      <section className="hero-section">
        <div className="page-container">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 text-charcoal animate-fade-in">
              Awards & Recognition
            </h1>
            <p className="text-xl text-titanium leading-relaxed animate-slide-up">
              This is the Awards & Recognition page with sample content.
            </p>
          </div>
        </div>
      </section>

      <section className="py-16 md:py-20 bg-white">
        <div className="page-container">
          <div className="max-w-4xl mx-auto">
            <p className="text-titanium mb-6">
              Sample content for Awards & Recognition. This page contains placeholder text and will be updated with actual content.
            </p>
            <Link to="/" className="btn-primary">Return Home</Link>
          </div>
        </div>
      </section>
    </>
  );
};

export default Awards;
